import Modal from 'components/ui/Modal/Modal'
import Loader from 'components/Loader/Loader'

const ModalWithStates = ({ isLoading, isError, onClose, children }) => {
  let content

  if (isLoading) {
    content = (
      <div className="modal-delete-articulo-container-loader">
        <Loader />
      </div>
    )
  } else if (isError) {
    content = <p style={{ padding: '2rem' }}>Error al cargar dependencias</p>
  } else {
    content = children
  }

  return (
    <Modal
      modalClass="modal modal-delete-articulo"
      containerChildrenClass="new-bimlink-container"
      onClose={onClose}
    >
      {content}
    </Modal>
  )
}

export default ModalWithStates
